import { render, staticRenderFns } from "./NewPasswordFields.vue?vue&type=template&id=4f768392&"
import script from "./NewPasswordFields.vue?vue&type=script&lang=js&"
export * from "./NewPasswordFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports